import React, { useEffect } from "react";
import classNames from "classnames";

import IndicatorSVG from "@components/icons/indicator-svg";
import LockSVG from "@components/icons/lock-svg";
import QueryHandler from "@components/query-handler/query-handler";

import { useAppDispatch, useAppSelector } from "@hooks/use-store";
import {
  currentCoinsUpload,
  progressUpload,
  setAdsForceRefresh,
} from "@store/app/app.slice";
import { IUserExercise } from "@typings/global.types";

import { useGetExerciseEntrypointQuery } from "../../api/exercise-entrypoint";
import { useUpdateUserInfoMutation } from "../../api/user-info";

type PropsType = {
  exercise: IUserExercise;
  closeModal?: () => void;
  lessonComplete: boolean;
};

function ItemExercise({ exercise, lessonComplete, closeModal }: PropsType) {
  const {
    data: entrypointData,
    isLoading: isEntrypointLoading,
    isError: isEntrypointError,
  } = useGetExerciseEntrypointQuery({
    exerciseId: 0,
  });

  const [editUser, { data, isLoading, isError, error, isSuccess }] =
    useUpdateUserInfoMutation();

  const dispatch = useAppDispatch();

  const handleChangeExercise = () => {
    if (!entrypointData) {
      return;
    }

    if (closeModal && exercise.id === entrypointData.exercise.id) {
      closeModal();
      return;
    }

    // dispatch(errorsUpdate(0));
    // dispatch(speedUpdate(0));
    // dispatch(startTypingUpload(0));
    dispatch(progressUpload(0));
    dispatch(currentCoinsUpload(0));
    // dispatch(correctUpdate(0));

    editUser({
      params: {
        currentExerciseId: exercise.id,
      },
    });

    if (closeModal) {
      closeModal();
    }

    dispatch(setAdsForceRefresh(true));
  };

  return (
    <QueryHandler
      isLoading={isEntrypointLoading}
      isError={isEntrypointError || isError}
      errorMessage={error}
    >
      <div className='px-1 pt-4'>
        {exercise.active ? (
          <div title={exercise.name}>
            <button
              type='button'
              className={classNames("btn btn-sm", {
                "btn-primary": exercise.id === entrypointData?.exercise.id,
                "btn-quaternary": exercise.id !== entrypointData?.exercise.id,
              })}
              onClick={handleChangeExercise}
            >
              {exercise.id === entrypointData?.exercise.id ||
              (exercise.id === entrypointData?.user.lastExerciseId &&
                !lessonComplete) ? (
                <svg
                  className='ml-[4px] h-[18px] w-auto md:h-[22px]'
                  viewBox='0 0 14 22'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0.93934 0.93934C1.52513 0.353553 2.47487 0.353553 3.06066 0.93934L13.1214 11L3.06066 21.0607C2.47487 21.6465 1.52513 21.6465 0.93934 21.0607C0.353553 20.4749 0.353553 19.5252 0.93934 18.9394L8.87872 11L0.93934 3.06066C0.353553 2.47487 0.353553 1.52513 0.93934 0.93934Z'
                    className='dark:fill-icon-dark-primary fill-icon-primary'
                  />
                </svg>
              ) : (
                <IndicatorSVG
                  classNameProps='h-[25px] w-auto md:h-[30px]'
                  star={exercise.star}
                  target={exercise.target}
                  lightning={exercise.lightning}
                />
              )}
            </button>
          </div>
        ) : (
          <div
            title={exercise.name}
            className='border-b-3 border-transparent p-2'
          >
            <LockSVG classNameProps='h-[25px] w-auto md:h-[30px]' />
          </div>
        )}

        <div className='pt-0.5 text-center text-small-xs md:text-small'>
          {exercise.orderId}
        </div>
      </div>
    </QueryHandler>
  );
}

export default ItemExercise;
